
export default function inlineWorker(scriptText, opts) {
  let blob = new Blob([scriptText], {type: 'text/javascript'});
  let url = URL.createObjectURL(blob);
  let worker = new Worker(url, opts);
  URL.revokeObjectURL(url);
  return worker;
}
